export default function NotFoundPage() {
  return (
    <div className="h-screen w-screen flex flex-col gap-4 justify-center items-center">
      <h1 className="text-5xl font-semibold">404</h1>
      <h2>We couldn't find the page you're looking for!</h2>
      <h4>Maybe the url is incorrect.</h4>
    </div>
  )
}
